import { createContext, useContext, useMemo } from "react";
import { useFlowID } from "./FlowIDContext";
import { useConfig } from "./ConfigContext";
import { FlowTrackerUrl } from "../constants";

const TrackerContext = createContext();

export const useTracker = () => useContext(TrackerContext);

const createDeviceId = () => {
  const key = "flow_device_id";

  let deviceId = localStorage.getItem(key);

  if (!deviceId) {
    deviceId = crypto.randomUUID();
    localStorage.setItem(key, deviceId);
  }

  return deviceId;
};

export const TrackerProvider = ({ children }) => {
  const flowId = useFlowID();
  const { configData } = useConfig();
  const deviceId = useMemo(() => createDeviceId(), []);

  const itrack = ({ eventName, trackerId, properties = {} }) => {
    if (!process.env.REACT_APP_FLOW_TRACKER_KEY) {
      return;
    }

    const payload = {
      tracking_key: process.env.REACT_APP_FLOW_TRACKER_KEY,
      tracker_id: trackerId,
      customer_id: configData.partnerName,
      branch_id: String(flowId),
      device_id: deviceId,
      event_name: eventName,
      event_properties: properties,
    };

    const body = JSON.stringify(payload);

    if (navigator.sendBeacon) {
      const blob = new Blob([body], { type: "text/plain" });
      const queued = navigator.sendBeacon(FlowTrackerUrl, blob);

      if (queued) return;
    }

    fetch(FlowTrackerUrl, {
      method: "POST",
      headers: {
        "content-type": "text/plain",
      },
      body,
      keepalive: true,
    }).catch(() => {});
  };

  return (
    <TrackerContext.Provider value={{ itrack }}>
      {children}
    </TrackerContext.Provider>
  );
};
